/* eslint-disable react-hooks/exhaustive-deps */
import adminIndex from "../../../components/adminIndex.module.css";
import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ConnectedStores from "./ConnectedStores";
import { Icon } from "@iconify/react";
import ProductReviewCard from "../../../../customer/pages/products/components/ProductReviewCard";
import PersonalInfo from "./PersonalInfo";
import { useDispatch, useSelector } from "react-redux";
import { getProductsByUser } from "../../../../../api/product";
import { productSelector } from "../../../../../redux/slices/productSlice";
import { Pagination, Stack } from "@mui/material";
import { getAllRecordsByUser } from "../../../../../api/store";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserDetailsTab({ findUser }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch()
  const {productsByUser} = useSelector(productSelector)


  const [page, setPage] = React.useState(1);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getProductsByUser({userId:findUser?._id, page:newPage-1, size:50}))
  };

  console.log("productsByUser",productsByUser)

  return (
    <Box className={adminIndex.card}>
      <Box>
        <Tabs
          value={value}
          sx={{
            position: "relative",
            zIndex: 1,
            "& .Mui-Selected": {
              color: "red",
            },
            ".MuiTabs-flexContainer": {
              background: "#FFFDF9!important",
            },
          }}
          onChange={handleChange}
          aria-label="basic tabs example"
          inkBarStyle={{ backgroundColor: "#000" }}
        >
          <Tab
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: value === 0 && "700",
                }}
              >
                <Icon
                  icon="mdi:user-online-outline"
                  width="20"
                  height="20"
                  style={{ color: "#6FD226", marginRight: "5px" }}
                />
                Personal Info
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
          onClick={() => dispatch(getAllRecordsByUser(findUser._id))}
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: value === 1 && "700",
                }}
              >
                <Icon
                  icon="maki:warehouse"
                  width="20"
                  height="20"
                  style={{ color: "#669BF4", marginRight: "5px" }}
                />
                Stores
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
          onClick={() => dispatch(getProductsByUser({userId:findUser?._id, page:0, size:50}))}
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: value === 1 && "700",
                }}
              >
                <Icon
                  icon="ep:goods"
                  width="20"
                  height="20"
                  style={{ color: "#9025FA", marginRight: "5px" }}
                />
                Products
              </div>
            }
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <PersonalInfo user={findUser} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ConnectedStores />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div style={{ paddingRight: "15px" }}>
          <ProductReviewCard products={productsByUser?.data?.products} title="user" />
        </div>
        <div className={adminIndex.footer}>
          <p style={{ margin: 0 }}>
            Total Products:{" "}
            <strong>{(productsByUser?.data?.totalProducts) ?? 0}</strong>
          </p>
          <Pagination
            onChange={handleChangePage}
            sx={{
              ".MuiPagination-root": {
                ".Mui-selected": {
                  backgroundColor: "#8D40FF",
                  color: "#fff",
                },
              },
            }}
            defaultPage={page}
            // status={value === 1 ? "Waiting": value === 2 ? "Processing":value===3 ? "Shipped":value===4 && "Pending"}
            count={Math.ceil(productsByUser?.data?.totalProducts/50)}
            shape="rounded"
          />
      </div>
      </TabPanel>
    </Box>
  );
}
